// extracted by mini-css-extract-plugin
module.exports = {"ProgressData":"ArchiveListBatchRestoreModal_ProgressData__29omN"};